// fork from @shopee/log-in-nonlive
import { config as platformConfig } from '@shopee-user/platform';
const { ENV } = platformConfig;
import { Env } from '@shopee-user/global';

// log for non-live environments
export default function logInNonLive(...args: any[]): void {
  if (ENV !== Env.Live) {
    // console.* calls will be removed when deployed, use self.* instead
    // see also: https://github.com/terser/terser/issues/187
    if (
      typeof self !== undefined &&
      self.console &&
      typeof self.console.log === 'function'
    ) {
      self.console.log(...args); // eslint-disable-line
    }
  }
}

export function logErrorInNonLive(...args: any[]): void {
  if (ENV !== 'live') {
    // console.* calls will be removed when deployed, use self.* instead
    // see also: https://github.com/terser/terser/issues/187
    if (
      typeof self !== undefined &&
      self.console &&
      typeof self.console.error === 'function'
    ) {
      self.console.error(...args); // eslint-disable-line
    }
  }
}
